module.exports = __webpack_public_path__ + "static/media/pop-out-button.809e9e49.svg";